import FundDetailsModalContainer from './FundDetailsModalContainer'

export default FundDetailsModalContainer
